// The header shown when a customer tries to add more cakes than an online order
// can hold: bulk orders are arranged on WhatsApp. Goes away when closed or on
// the next page.
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { FaWhatsapp } from "react-icons/fa";
import { FiX } from "react-icons/fi";
import { WHATSAPP_SHOP } from "common/shopItems";
import { BULK_EVENT } from "utils/cart";
import "./style.css";

export default function BulkBanner() {
  const { t } = useTranslation("shop");
  const { pathname } = useLocation();
  const [show, setShow] = useState(false);
  useEffect(() => {
    const open = () => setShow(true);
    window.addEventListener(BULK_EVENT, open);
    return () => window.removeEventListener(BULK_EVENT, open);
  }, []);
  useEffect(() => setShow(false), [pathname]);
  if (!show) return null;
  return (
    <div className="bulk-banner" role="alert">
      <div className="bulk-banner-text">
        <b>{t("buy.bulkTitle")}</b>
        <span>{t("buy.bulk")}</span>
      </div>
      <a
        className="btn btn-success bulk-banner-btn"
        href={`https://wa.me/${WHATSAPP_SHOP}?text=${encodeURIComponent(t("buy.bulkMessage"))}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FaWhatsapp /> {t("buy.bulkButton")}
      </a>
      <button
        type="button"
        className="bulk-banner-close"
        aria-label={t("buy.bulkClose")}
        onClick={() => setShow(false)}
      >
        <FiX />
      </button>
    </div>
  );
}
